<div class="grid-container">

    <div class="grid-item grid-item-01" *ngIf="product">
        <a [routerLink]="['/']">Productos</a> /
        <a [routerLink]="['/productTypes',product.productType.productTypeId]">{{product.productType.title}}</a> /
        {{product.title}}
    </div>

    <div class="grid-item grid-item-02 product-carousel">
        <figure class="thumbnailContainer">
            <slideshow #slideshow [imageUrls]="product.imagesSlider" [autoPlay]="true" [showCaptions]="false" [stopAutoPlayOnSlide]="true" [showDots]="true" [autoPlayInterval]="9999"></slideshow>
        </figure>
        </div>
        <div class="grid-item grid-item-03">
            <div class='product-description'>
                <div class="product-title"><h2>{{product.title}}</h2></div>
            </div>
            <div class='product-description'>
                <div class="product-description"><h4>{{product.description}}</h4></div>
            </div>
            <div *ngIf="product.price !== undefined && product.price !=null && product.price>0" class="product-price-section" >
                <h6 class="product-price-title"><small>PRECIO</small></h6>
                <div class="product-price"> <h3> {{product.price | currency:"USD": true}}</h3></div>
            </div>
            <div *ngIf="product.featuredDetails !== undefined && product.featuredDetails !=null && product.featuredDetails.length>0">
                <ul>
                    <li *ngFor="let pd of product.featuredDetails">
                        {{pd.value}}
                    </li>
                </ul>
            </div>
        </div>

        <div class="grid-item grid-item-04" *ngIf="product.features.length>0">
            <div class="wrap-collabsible">
                <input id="collapsibleFeatures" class="toggle" type="checkbox" checked>
                <label for="collapsibleFeatures" class="lbl-toggle">Características</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <ul>
                            <li *ngFor="let pd of product.features">
                                {{pd.value}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-item grid-item-05" *ngIf="product.tests.length>0">
            <div class="wrap-collabsible">
                <input id="collapsibleTests" class="toggle" type="checkbox" checked>
                <label for="collapsibleTests" class="lbl-toggle">Pruebas incorporadas</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <ul>
                            <li *ngFor="let pd of product.tests">
                                {{pd.value}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-item grid-item-06" *ngIf="product.technicalSpecifications.length>0">
            <div class="wrap-collabsible">
                <input id="collapsible" class="toggle" type="checkbox" checked>
                <label for="collapsible" class="lbl-toggle">Especificaciones técnicas</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <div *ngFor="let pd of product.technicalSpecifications">
                            <div [innerHTML]="pd.value">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-item grid-item-07" *ngIf="product.transducers.length>0">
            <div class="wrap-collabsible">
                <input id="collapsibleTransducers" class="toggle" type="checkbox" checked>
                <label for="collapsibleTransducers" class="lbl-toggle">Transductores</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <ul>
                            <li *ngFor="let pd of product.transducers">
                                {{pd.value}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-item grid-item-08" *ngIf="product.standards.length>0">
            <div class="wrap-collabsible">
                <input id="collapsibleStandards" class="toggle" type="checkbox" checked>
                <label for="collapsibleStandards" class="lbl-toggle">Normas</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <ul>
                            <li *ngFor="let pd of product.standards">
                                {{pd.value}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-item grid-item-09" *ngIf="product.otherCharacteristics.length>0">
            <div class="wrap-collabsible">
                <input id="collapsibleOtherCharacteristics" class="toggle" type="checkbox" checked>
                <label for="collapsibleOtherCharacteristics" class="lbl-toggle">Otras características</label>
                <div class="collapsible-content">
                    <div class="content-inner">
                        <ul>
                            <li *ngFor="let pd of product.otherCharacteristics">
                                {{pd.description}}: {{pd.value}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-item grid-item-10">
            <button class="btn btn-outline-secondary"
                    (click)="onBack()"
                    style="width: 90px">
                <i class="fa fa-chevron-left"></i> Volver
            </button>
            <a class="btn btn-informacion" title="Mas información" href="/contact?subject=Consulta por {{product.title}}"><i class="fa fa-info-circle linkIcon"></i> Mas información</a>
        </div>
    </div>
